import React from 'react';
import ReactDOM from 'react-dom';
//import App from './App';
import reportWebVitals from './reportWebVitals';
import Routes from './routes';


ReactDOM.render(
  
  <React.StrictMode>    
    <Routes />    
  </React.StrictMode>,
  
  document.getElementById('root'),
);

reportWebVitals();
